import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { createLocalizedUrl } from '../utils/languageUtils';
import { useLanguage } from '../contexts/LanguageContext';

const CompareSpanishCities = ({ className = '' }) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  const cities = [
    { city: 'Madrid', icon: '🏰' },
    { city: 'Barcelona', icon: '🏖' },
    { city: 'Valencia', icon: '🍊' },
    { city: 'Sevilla', icon: '🎭' },
    { city: 'Malaga', icon: '☀️' },
    { city: 'Bilbao', icon: '🏛' },
    { city: 'Alicante', icon: '🌅' },
    { city: 'Zaragoza', icon: '⛪️' },
    { city: 'Cordoba', icon: '🕌' },
    { city: 'Valladolid', icon: '🏺' }
  ];

  return (
    <div className={`mt-8 pt-6 border-t border-gray-200 ${className}`}>
      <div className="flex flex-col items-center">
        <h2 className="text-sm font-semibold text-gray-900 mb-3">
          {t('common.compareSpanishCities')}
        </h2>
        <div className="flex flex-nowrap overflow-x-auto gap-3 pb-2 w-full justify-center">
          {cities.map(({ city, icon }) => (
            <Link
              key={city}
              to={createLocalizedUrl(`/cost-explorer/${city.toLowerCase()}`, currentLanguage)}
              className="flex items-center gap-1.5 px-2 py-1.5 bg-gray-50 rounded-md hover:bg-gray-100 transition-all duration-300 whitespace-nowrap group"
            >
              <span className="text-base group-hover:scale-110 transition-transform">
                {icon}
              </span>
              <span className="text-xs text-gray-600 group-hover:text-blue-600 transition-colors">
                {city}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompareSpanishCities;






